// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAs2rjsj7URQa31ItshRQcoFLmYHqps1Sc",
  authDomain: "gaspricechecker-6598e.firebaseapp.com",
  projectId: "gaspricechecker-6598e",
  storageBucket: "gaspricechecker-6598e.firebasestorage.app",
  messagingSenderId: "974638806626",
  appId: "1:974638806626:web:fcb73805e4318a0d14433b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services for use in your components
export const db = getFirestore(app);
